import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { CommercialComponent } from './commercial.component';
import { EnrollmentComponent } from './enrollment/enrollment.component';
import { GetStartedComponent } from './get-started/get-started.component';
import { HomeMainComponent } from './home-main/home-main.component';
import { QuestionnaireComponent } from './questionnaire/questionnaire.component';
import { PreCongratsComponent } from './enrollment/pre-congrats/pre-congrats.component';
import { CongratsComponent } from './enrollment/congrats/congrats.component';
import { ConfirmEnrollmentComponent } from './enrollment/confirm-enrollment/confirm-enrollment.component';
import { Error400Component } from '../home-main/solution/residential/400error.component';

const routes: Routes = [
  { path: 'commercial', component: HomeMainComponent },
  { path: 'commercial/get-started', component: GetStartedComponent },
  {
    path: 'commercial/enrollment',
    component: ConfirmEnrollmentComponent,
  },
  {
    path: 'commercial/questionnaire',
    component: QuestionnaireComponent,
  },
  { path: 'commercial/pre-congrats', component: PreCongratsComponent },
  { path: 'commercial/congrats', component: CongratsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CommercialRoutingModule {}
